module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-bottom-backplates-remnants.c693f2bc.png";